import React, { useState } from "react"
import { NavSection } from "./utils/nav-section"
import { NavLink } from "./utils/nav-link"
import { menu } from "./utils/menu-definitions"
import useCurrentUser from "hooks/use-current-user"

import "./primary-nav.css"

export const showLinksByFeature = (menuSection, filters) => {
  return menuSection.links.filter(link => filters[link.label] !== false)
}

const PrimaryNav = () => {
  const [activeMenu, setActive] = useState()
  const user = useCurrentUser()
  const userOnTrial = user.onTrial
  const cksnProgrammaticAdsEnabled = user?.canViewAds
  const canViewPaidRecommendations = user?.canUsePaidRecommendations

  return (
    <nav className="h-full items-center gap-6 hidden lg:flex">
      {Object.keys(menu).map(section => (
        <NavSection
          title={menu[section].title}
          updateActive={setActive}
          active={activeMenu}
          key={menu[section].title}
        >
          {showLinksByFeature(menu[section], {
            Ads: cksnProgrammaticAdsEnabled,
            "Paid Recommendations": canViewPaidRecommendations
          }).map(link => (
            <NavLink
              {...link}
              userOnTrial={userOnTrial}
              section={section}
              key={link.label}
            />
          ))}
        </NavSection>
      ))}
    </nav>
  )
}

export { PrimaryNav }
